import React from 'react';
import {
  HFP_CARD_DISCLAIMER_SUMMARY,
  HFP_NON_DIAGNOSTIC_STATEMENT,
  HFP_NO_SCORING_STATEMENT,
  HFP_USAGE_GUIDANCE,
} from '../../constants/hfpDisclaimer';

/**
 * HfpCardDisclaimer
 * -----------------
 * The always-visible non-diagnostic line on the clinician HFP card, with the
 * agreed full statements and usage guidance one disclosure away. The summary
 * line never collapses — prominence is the point (the profile must not be
 * read as a diagnosis, however many priority areas are highlighted).
 */
export default function HfpCardDisclaimer() {
  return (
    <div className="mt-3 rounded-lg border border-blue-200 bg-blue-50 p-3 text-left">
      <p className="text-xs font-medium text-blue-900">{HFP_CARD_DISCLAIMER_SUMMARY}</p>
      <details className="mt-1">
        <summary className="cursor-pointer text-xs font-medium text-blue-800 underline">
          About this profile and how to use it
        </summary>
        <div className="mt-2 space-y-2 text-xs text-blue-900">
          <p>{HFP_NON_DIAGNOSTIC_STATEMENT}</p>
          <p>{HFP_NO_SCORING_STATEMENT}</p>
          <ul className="ml-4 list-disc space-y-1">
            {HFP_USAGE_GUIDANCE.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </div>
      </details>
    </div>
  );
}
